module.exports = __webpack_public_path__ + "assets/img/login_tu1.bf1bcf4c.png";